namespace Areas.Inspections {
    "use strict";

    export function cellPreparedPivotGrid(e) {

        if (e.area == "data") {
            if (e.cell.text != "undefined" && e.cell.text != "") {
                var linkInfo = e.cell.value;
                e.cellElement.html(linkInfo);
            }
            else if (e.cell.rowPath.length > 1) {

                var inspectionProjectId = $('#InspectionPivotGrid').dxPivotGrid('instance').option("inspectionProjectId");
                var url = "/Inspections/Create/Index/" + inspectionProjectId
                    + "?inspectionType=" + encodeURIComponent(e.cell.rowPath[0])
                    + "&inspectionSubType=" + encodeURIComponent(e.cell.rowPath[1])
                    + "&inspectionGroup=" + encodeURIComponent(e.cell.columnPath[0]);
                e.cellElement.html("<a href='" + url + "' target=_blank>+++</a>");
            }
        }
    }

    export function calculateSummaryValue(args) {

        if (args.field("row")) {
            if (args.field("row").dataField === "inspectionTypeLk") {
                return "";  //Show blank on the InspectionTypeLk summary row
            }
            else {
                return args.value("html") || "";    //Return an empty string if value is null to prevent cell from being hidden
            }
        }
        else {
            //Not sure what element this is for, but we'll pass it along
            return args.value("html");
        }
    }
}